<ngrx-busy>
  <form [formGroup]="form"
    (ngSubmit)="save()"
    class="side-form">

    <h3>{{mode === EditMode.Edit ? 'Update' : 'Create'}} jig</h3>

    @if (mode === EditMode.Create) {
      <mat-form-field appearance="fill">
        <mat-label>Id</mat-label>
        <input matInput
          formControlName="id">
      </mat-form-field>
    }

    <mat-form-field appearance="fill">
      <mat-label>Short Id</mat-label>
      <input matInput
        formControlName="short_id">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Settings</mat-label>
      <input matInput
        formControlName="settings">
    </mat-form-field>

    <div class="side-form-actions">
      <button mat-raised-button
        type="submit"
        color="primary"
        [disabled]="form.invalid">
        {{mode === EditMode.Edit ? 'Update' : 'Create'}}
      </button>
    </div>

    <app-form-error></app-form-error>
  </form>
</ngrx-busy>
